// Default menu settings configurations

export interface MenuAdminItem {
    title: string;
    icon: string;
    page: string;
    isExternalLink?: boolean;
    issupportExternalLink?: boolean;
    isStarterkitExternalLink?: boolean;
    badge: { type: string, value: string };
    submenu: {
      items: Partial<MenuAdminItem>[];
    };
    section: string;
  }
  
  export interface MenuConfig {
    vertical_menu: {
      items: Partial<MenuAdminItem>[]
    };
  }
  
  export const MenuAdminSettingsConfig: MenuConfig = {
    vertical_menu: {
      items: [
        { section: 'Gestión ', icon: 'la-cogs' },
        {
          title: 'Dashboard',
          icon: 'icon-bar-chart',
          page: '/onlyadminaccess/dashboard'
        },
        {
          title: 'Nuevas ofertas',
          icon: 'la-check-square',
          page: '/onlyadminaccess/ofertas'
        },
        {
          title: 'Ofertas Activas',
          icon: 'la-briefcase',
          page: '/onlyadminaccess/ofertas-activas'
        },
        {
          title: 'Empresas Afiliadas',
          icon: 'la-building-o',
          page: '/onlyadminaccess/empresas',
        },
        { section: 'Administración ', icon: 'la-houzz' },
        {
          title: 'Catálogos',
          icon: 'la-tasks',
          page: '/onlyadminaccess/gestion'
        },
        {
          title: 'Docentes',
          icon: 'la-stack-overflow',
          page: 'null',
          submenu: {
            items: [
              {
                title: 'Lista',
                icon: 'la-list',
                page: '/onlyadminaccess/lista-docentes'
              },
              {
                title: 'Crear cuenta',
                icon: 'la-cart-plus',
                page: '/onlyadminaccess/docentes'
              }
            ]
          }
        },
        {
          title: 'Egresados',
          icon: 'icon-graduation',
          page: 'null',
          submenu: {
            items: [
              {
                title: 'Seguimiento postulación',
                icon: 'la-list',
                page: '/onlyadminaccess/lista-egresados'
              },
              {
                title: 'Crear cuenta',
                icon: 'la-cart-plus',
                page: '/onlyadminaccess/egresados'
              } 
            ]
          }
        },
        {
          title: 'Administradores',
          icon: 'la-user-secret',
          page: 'null',
          submenu: {
            items: [
              {
                title: 'Lista',
                icon: 'la-list',
                page: '/onlyadminaccess/lista-administradores'
              },
              {
                title: 'Crear cuenta',
                icon: 'la-cart-plus',
                page: '/onlyadminaccess/administradores'
              }
            ]
          }
        },
        {
          title: 'Crear cuenta de empresa',
          icon: 'la la-medkit',
          page: '/onlyadminaccess/empresas/crear-cuenta'
        },
        { section: 'Control' }
      ]
    }
  
  };
  
  
  
  
  
  